<template>
  <div class="act_layout stem_panel">
    <div class="stem_row lv_flexalign_center">
      <span class="stem_label">显示</span>
      <van-switch
        v-model="showStem"
        size="24px"
        active-color="#6e9f21"
        inactive-color="#d7d7d7"
        @change="handleSwitchChange"
      />
    </div>

    <div class="stem_row lv_flexalign_center">
      <span class="stem_label">粗细</span>
      <van-stepper
        v-model="stemRadius"
        theme="round"
        button-size="22"
        integer
        min="1"
        :step="1"
        @change="handleRadiusChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      showStem: true,
      stemRadius: 1,
    };
  },
  methods: {
    init(item) {
      this.id = item ? item.id : "";
      this.showStem = item ? item.showStem !== false : true;
      this.stemRadius = item && item.stemRadius ? item.stemRadius : 1;
    },
    handleSwitchChange(status) {
      if (!this.id) {
        return;
      }
      this.$bus.$emit("setStemVisible", {
        id: this.id,
        value: status,
      });
    },
    handleRadiusChange(value) {
      this.stemRadius = Math.max(1, Math.round(value - 0 || 1));
      if (!this.id) {
        return;
      }
      this.$bus.$emit("setStemRadius", {
        id: this.id,
        value: this.stemRadius,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.stem_panel {
  padding: 0 rem(40);
}

.stem_row + .stem_row {
  margin-top: rem(22);
}

.stem_label {
  width: rem(88);
  font-size: rem(26);
  color: #333;
}
</style>

<style lang="scss">
.stem_panel {
  .van-stepper--round .van-stepper__plus {
    background-color: #6e9f21;
  }

  .van-stepper--round .van-stepper__minus {
    color: #6e9f21;
    border-color: #6e9f21;
  }

  .van-stepper__input {
    min-width: rem(72);
    font-size: rem(28);
  }
}
</style>
